import React from 'react'
import ReportListItem from './ReportListItem'
import emptyBoxIcon from "../assets/emptyBoxIcon.png"

import styled, { keyframes } from "styled-components"
import { fadeInLeft } from 'react-animations'

const fadeInLeftAnimation = keyframes`${fadeInLeft}`
const FadeInLeftDiv = styled.div`animation: 1s ${ fadeInLeftAnimation };`

const ReportList = (props) => {
  const { reports, handleReportClick } = props

  return (
    <FadeInLeftDiv id="reportListDiv" className="bg-gray-500 w-60 h-96 rounded-md divide-y-4 divide-gray-500 overflow-y-auto">
      <p className="text-white font-semibold text-lg mt-1">Reports</p>
      { reports.length === 0 ?
        <img src={emptyBoxIcon} className="absolute top-80 ml-20"/> :
        reports.map((report) => {
          return <ReportListItem key={report} report={report} handleReportClick={handleReportClick} />
        })
      }
    </FadeInLeftDiv>
  )
}

export default ReportList
